export const DELIVERY_METHOD = "Delivery";
export const PICKUP_METHOD = "Self Collection";
export const PICKUP_BALESTIER = "Balestier";
export const PICKUP_CHINATOWN = "Chinatown";
export const PREFERRED_NONE = "No Pref";
export const PREFERRED_MORNING = "AM";
export const PREFERRED_AFTERNOON = "PM";
export const API_URL = "https://www.happydoppisweets.com/api";